const batchType = require('../../batchType');
const batchStatus = require('../../batchStatus');

const bat = {
  BATCH_HAS_NO_TRANSFERS: {
    message: 'Your batch has no transfers, register transfers to close it.',
    field: 'transfers',
    code: 'BAT_1'
  },
  BANK_ACCOUNT_NOT_FILLED_YET: {
    message: 'You havent informed your bank account data yet, please access our web app to fill it',
    field: 'received_bank_account_id',
    code: 'BAT_2'
  },
  INVALID_BATCH_TYPE: {
    message: `The batch type must be "${batchType.TRANSFER}" or "${batchType.BILLET}"`,
    field: 'type',
    code: 'BAT_3'
  },
  INVALID_BATCH_NAME: {
    message: 'Invalid batch name',
    field: 'name',
    code: 'BAT_4'
  },
  INVALID_BATCH_UPDATE: {
    message: `The current batch status does not allow updates. Changes are only allowed in batches with the status ${batchStatus.DRAFT} or ${batchStatus.FINISHED}, in this case, only the reconciled field`,
    code: 'BAT_5'
  },
  TOO_MANY_PAYMENTS: {
    message: `The batch cannot have more than {{size}} payments (transfers/billets)`,
    code: 'BAT_6',
    variable: 'size'
  },
  MAX_DAILY_VALUE: {
    message: 'The batch amount is greater than the daily limit allowed (R$ {{maxValue}})',
    field: 'value',
    variable: 'maxValue',
    code: 'BAT_7'
  },
  MAX_SCHEDULED_DAILY_VALUE: {
    message: 'Payments scheduled for the day {{date}} are greater than the daily limit allowed (R$ {{maxValue}})',
    field: 'value',
    variable: ['maxValue', 'date'],
    code: 'BAT_8'
  },
  BATCH_LOCKED: {
    message:
      'There is another operation currently changing this batch in parallel and the change has not been applied.',
    field: 'batch',
    code: 'BAT_9'
  },
  BATCH_CANNOT_BE_CANCELED: {
    message: 'The batch cannot be canceled',
    code: 'BAT_10'
  }
};

module.exports = bat;
